import { memo } from "react";

import { PERMISSIONS } from "shared/Actions/constants";
import TableCellDescription from "ds/components/Table/Row/CellDescription";

import { RenderGroupRowCellProps } from "../../Group/Content";
import PersonalSettingsSpacesItemCell from "../Cell";
import { isActionItem } from "../../../helpers";

const PersonalSettingsSpacesTableGroupRowCellDescription = memo(
  (props: RenderGroupRowCellProps) => {
    const { row } = props;

    return (
      <PersonalSettingsSpacesItemCell {...props}>
        <TableCellDescription
          description={isActionItem(row) ? PERMISSIONS[row.actionID].description : ""}
        />
      </PersonalSettingsSpacesItemCell>
    );
  }
);

PersonalSettingsSpacesTableGroupRowCellDescription.displayName =
  "PersonalSettingsSpacesTableGroupRowCellDescription";

export default PersonalSettingsSpacesTableGroupRowCellDescription;
